// ===============================
// UK CPB Script — Price + Klarna + Clearpay (STATIC KLARNA)
// Klarna shows base price only (no dynamic updates) 
// ===============================

window.PXUTheme.contentCreator.accordion = {
  init: function () {
    const $accordionHeading = $(
      ".accordion > dt > a, [data-cc-accordion] > dt > a"
    );
    $(".accordion > dd, [data-cc-accordion] > dd").attr("aria-hidden", true);
    $accordionHeading.attr("aria-expanded", false);
    $accordionHeading.on("click", function () {
      let state = $(this).attr("aria-expanded") === "false" ? true : false;
      $(this).attr("aria-expanded", state);
      $(this).parent().next().attr("aria-hidden", !state);
      return false;
    });
    $accordionHeading.on("keydown", function (event) {
      let keyCode = event.keyCode || event.which;
      if (keyCode === 13) {
        $(this).trigger("activate");
      }
    });
  },
  unload: function () {
    $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("click activate");
    $(".accordion > dt > a, [data-cc-accordion] > dt > a").off("keydown");
  },
};

(function ($) {
  'use strict';

  /* -------------------------------------------
   * Accordion module (delegated, no dbl-toggle)
   * ----------------------------------------- */
  window.PXUTheme.contentCreator.accordion = window.PXUTheme.contentCreator.accordion || {
    _bound: false,
    _handleClick: null,

    init() {
      if (this._bound) return;

      const containers = document.querySelectorAll('.accordion, [data-cc-accordion]');
      if (!containers.length) return;

      containers.forEach(container => {
        container.querySelectorAll('dd').forEach(el => el.setAttribute('aria-hidden', 'true'));
        container.querySelectorAll('dt > a').forEach(el => el.setAttribute('aria-expanded', 'false'));
      });

      this._handleClick = (e) => {
        const target = e.target.closest('.accordion > dt > a, [data-cc-accordion] > dt > a');
        if (!target) return;

        e.preventDefault();

        const isExpanded = target.getAttribute('aria-expanded') === 'true';
        const content = target.parentElement?.nextElementSibling;

        target.setAttribute('aria-expanded', String(!isExpanded));
        if (content) content.setAttribute('aria-hidden', String(isExpanded));
      };

      document.addEventListener('click', this._handleClick);
      this._bound = true;
    },

    unload() {
      if (!this._bound) return;
      document.removeEventListener('click', this._handleClick);
      this._handleClick = null;
      this._bound = false;
    }
  };

  /* -------------------------------------------
   * Main CPB module
   * ----------------------------------------- */
  const CONFIG = {
    DEBUG: false,
    RETRY_DELAYS_MS: [0, 80, 200, 450, 900],
    OOS_RETRY_DELAYS_MS: [150, 500, 1200],

    ENABLE_KLARNA: true,
    ENABLE_AFTERPAY: true,

    KLARNA_FIND_SEL: 'klarna-placement',
    AFTERPAY_DEBOUNCE: 250
  };

  const state = {
    builder: null,
    panelsContainer: null,

    customPricesContainer: null,
    freeAddonData: null,
    freeAddonTeaser: null,
    priceObserver: null,
    rafId: null,

    // Klarna
    klarnaWrap: null,
    klarnaInitialized: false,
    klarnaBasePence: null,
    movedKlarnaOnce: false,

    // Clearpay / Afterpay
    afterpayWrap: null,
    updatingAfterpay: false,
    afterpayDebounceTimer: null,
    lastAfterpayAmount: null,

    timeouts: new Set(),
    mountedId: null
  };

  /* -------------------------------------------
   * Utilities
   * ----------------------------------------- */
  const utils = {
    qs: (sel, parent = document) => parent.querySelector(sel),
    qsa: (sel, parent = document) => parent.querySelectorAll(sel),

    log(...args) {
      if (CONFIG.DEBUG) console.log('CPB-UK:', ...args);
    },
    error(...args) {
      console.error('CPB-UK:', ...args);
    },

    setTrackedTimeout(fn, delay) {
      const id = setTimeout(() => {
        state.timeouts.delete(id);
        fn();
      }, delay);
      state.timeouts.add(id);
      return id;
    },

    clearAllTimeouts() {
      state.timeouts.forEach(clearTimeout);
      state.timeouts.clear();
      if (state.afterpayDebounceTimer) {
        clearTimeout(state.afterpayDebounceTimer);
        state.afterpayDebounceTimer = null;
      }
    },

    retry(fn, delays = CONFIG.RETRY_DELAYS_MS) {
      delays.forEach(delay => {
        utils.setTrackedTimeout(() => {
          try { fn(); } catch (_) {}
        }, delay);
      });
    },

    isVisible(el) {
      return !!(el && el.offsetParent !== null);
    },

    isElementShown(el) {
      if (!el || !el.isConnected) return false;
      const style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    },

    newMountId() {
      return `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    }
  };

  /* -------------------------------------------
   * Cleanup
   * ----------------------------------------- */
  function cleanup() {
    utils.clearAllTimeouts();

    if (state.rafId) {
      cancelAnimationFrame(state.rafId);
      state.rafId = null;
    }

    if (state.priceObserver) {
      state.priceObserver.disconnect();
      state.priceObserver = null;
    }

    window.PXUTheme.contentCreator.accordion?.unload?.();

    state.builder = null;
    state.panelsContainer = null;
    state.customPricesContainer = null;
    state.freeAddonData = null;
    state.freeAddonTeaser = null;
    state.klarnaWrap = null;
    state.afterpayWrap = null;
    state.klarnaInitialized = false;
    state.klarnaBasePence = null;
    state.movedKlarnaOnce = false;
    state.updatingAfterpay = false;
    state.lastAfterpayAmount = null;
    state.mountedId = null;
  }

  function initGlobals() {
    state.builder = utils.qs('#product-builder');
    if (!state.builder) return false;

    state.panelsContainer = utils.qs('.cpb-panels-container', state.builder);
    return !!state.panelsContainer;
  }

  function getProductForm() {
    return utils.qs('.product_form[data-product-form], .shopify-product-form');
  }

  function getPreorderConfig() {
    const productForm = getProductForm();
    if (!productForm) return null;

    const hasPreorderText = productForm.getAttribute('data-has-preorder-text') === 'true';
    const preorderText = productForm.getAttribute('data-preorder-text') || '';
    const stockOutOverride = productForm.getAttribute('data-stock-out-override') === 'true';
    let variantInventory = productForm.getAttribute('data-variant-inventory');
    let variantInventoryList = [];

    if (variantInventory) {
      try {
        variantInventoryList = JSON.parse(variantInventory);
      } catch (error) {
        utils.error('Unable to parse variant inventory JSON', error);
      }
    }

    const selectedVariantInput = utils.qs('[data-variants]', productForm);
    const selectedVariantId = selectedVariantInput ? Number(selectedVariantInput.value) : null;
    const inventoryItem = variantInventoryList.find(item => Number(item.id) === selectedVariantId) || variantInventoryList[0] || null;
    const isPreOrder = !!(
      !stockOutOverride
      && hasPreorderText
      && preorderText
      && inventoryItem
      && inventoryItem.inventory_management
      && inventoryItem.inventory_policy === 'continue'
      && Number(inventoryItem.inventory_quantity) <= 0
    );

    return {
      hasPreorderText,
      preorderText,
      stockOutOverride,
      isPreOrder
    };
  }

  function renderPreorderBadge(preorderText) {
    if (!state.panelsContainer || !preorderText) return;

    const existing = utils.qs('.cpb-preorder-badge, .cpb-backorder-badge', state.panelsContainer);
    if (existing) existing.remove();

    const titleAnchor = utils.qs('.cpb-product-title', state.panelsContainer);
    const fallbackAnchor = utils.qs('.cpb-custom-prices-container, .cpb-product-price', state.panelsContainer);
    const anchor = titleAnchor || fallbackAnchor;
    if (!anchor) return;

    const badge = document.createElement('div');
    badge.className = 'cpb-preorder-badge';
    badge.title = 'This product is available for pre-order. Dispatch date is an estimate and is subject to change.';
    badge.innerHTML = '<span class="dot"></span><span></span>';
    badge.querySelector('span:last-child').textContent = preorderText;

    if (titleAnchor) {
      anchor.insertAdjacentElement('beforebegin', badge);
    } else {
      anchor.insertAdjacentElement('afterend', badge);
    }
  }

  function removePreorderBadge() {
    if (!state.panelsContainer) return;
    const existing = utils.qs('.cpb-preorder-badge, .cpb-backorder-badge', state.panelsContainer);
    if (existing) existing.remove();
  }

  function updateCPBButton(label, disabled) {
    if (!state.panelsContainer) return;

    const button = utils.qs('.cpb-add-to-cart-button', state.panelsContainer);
    if (!button) return;

    button.innerHTML = `<span>${label}</span>`;

    if (disabled) {
      button.setAttribute('disabled', true);
      button.disabled = true;
    } else {
      button.removeAttribute('disabled');
      button.disabled = false;
    }
  }

  function syncPreorderState() {
    const preorderConfig = getPreorderConfig();
    if (!preorderConfig || !state.panelsContainer) return;

    if (preorderConfig.stockOutOverride) {
      removePreorderBadge();
      updateCPBButton('Out of stock', true);
      return;
    }

    if (preorderConfig.isPreOrder) {
      renderPreorderBadge(preorderConfig.preorderText);
      updateCPBButton('Pre-Order', false);
      return;
    }

    removePreorderBadge();
  }

  /* -------------------------------------------
   * Price formatting (£, commas, no decimals)
   * ----------------------------------------- */
  const PRICE_REGEX = /(\d[\d,]*)/;

  function formatPrice(text) {
    const raw = (text || '').trim();
    const match = raw.match(PRICE_REGEX);
    if (!match) return '£0';

    const wholeNumber = match[1].replace(/,/g, '');
    const withCommas = wholeNumber.replace(/\B(?=(\d{3})+(?!\d))/g, ',');

    return `£${withCommas}`;
  }

  /* -------------------------------------------
   * Price sources (for Klarna/Afterpay)
   * ----------------------------------------- */
  function getPriceFromCPBState() {
    try {
      const st = (typeof CPB?.App === 'function')
        ? CPB.App().getStore().getState()
        : CPB?.App?.getStore?.()?.getState?.();

      const raw = st?.Product?.price;
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : null;
    } catch {
      return null;
    }
  }

  function getPriceFromDOMFallback() {
    const el = utils.qs('.cpb-product-price', state.panelsContainer)
      || utils.qs('.cpb-custom-product-price');

    if (!el) return null;

    const txt = (el.textContent || '').trim();
    const n = parseFloat(txt.replace(/[^0-9.]/g, ''));
    return Number.isFinite(n) && n > 0 ? n : null;
  }

  function poundsToPenceInt(pounds) {
    const n = Number(pounds);
    if (!Number.isFinite(n)) return null;
    return Math.max(0, Math.round(n * 100));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function formatMoneyPence(cents) {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount) || amount <= 0) return '';

    const hasDecimals = !Number.isInteger(amount);
    return `£${amount.toLocaleString('en-GB', {
      minimumFractionDigits: hasDecimals ? 2 : 0,
      maximumFractionDigits: 2
    })}`;
  }

  function getFreeAddonData() {
    const node = document.getElementById('gp-frame-free-addon-data');
    if (!node) return null;

    try {
      const parsed = JSON.parse(node.textContent || '{}');
      const title = String(parsed.title || '').trim();
      const image = String(parsed.image || '').trim();
      const compareAtCents = Number(parsed.compareAtCents || 0);

      if (!title && !image && compareAtCents <= 0) return null;

      return { title, image, compareAtCents };
    } catch (error) {
      utils.error('Unable to parse free add-on data', error);
      return null;
    }
  }

  function buildFreeAddonMarkup(data) {
    const title = escapeHtml(data?.title || '');
    const image = escapeHtml(data?.image || '');
    const compareAtText = data?.compareAtCents > 0
      ? `Valued at ${formatMoneyPence(data.compareAtCents)}`
      : '';

    if (!title && !image && !compareAtText) return '';

    return `
      ${image ? `
        <div class="gp-frame-free-addon-offer__media">
          <img src="${image}" alt="${title || 'Free add-on'}" loading="eager" width="72" height="72">
        </div>
      ` : ''}
      <div class="gp-frame-free-addon-offer__content">
        <h3 class="gp-frame-free-addon-offer__title">${title ? `INCLUDES FREE ${title}` : 'Free add-on included'}</h3>
        ${compareAtText ? `<div class="gp-frame-free-addon-offer__compare">${compareAtText}</div>` : ''}
      </div>
    `;
  }

  function ensureFreeAddonTeaser() {
    if (!state.freeAddonData) {
      state.freeAddonData = getFreeAddonData();
    }

    if (!state.freeAddonData) return false;

    const markup = buildFreeAddonMarkup(state.freeAddonData);
    if (!markup) return false;

    if (!state.freeAddonTeaser) {
      state.freeAddonTeaser = document.createElement('div');
      state.freeAddonTeaser.className = 'gp-frame-free-addon-teaser gp-frame-free-addon-offer';
      state.freeAddonTeaser.setAttribute('data-frame-free-addon-teaser', '');
    }

    state.freeAddonTeaser.innerHTML = markup;

    return true;
  }

  /* -------------------------------------------
   * Custom price element
   * ----------------------------------------- */
  function findBestPriceEl() {
    const prices = Array.from(utils.qsa('.cpb-product-price', state.panelsContainer));
    if (!prices.length) return null;

    const visible = prices.slice().reverse().find(utils.isVisible);
    return visible || prices[prices.length - 1];
  }

  function ensureCustomPriceContainer() {
    if (state.customPricesContainer) {
      ensureFreeAddonTeaser();
      return true;
    }

    const realPrice = findBestPriceEl();
    if (!realPrice) return false;

    const container = document.createElement('div');
    container.className = 'cpb-custom-prices-container';

    const priceWrapper = document.createElement('div');
    priceWrapper.className = 'cpb-custom-product-price-container';

    const customPrice = document.createElement('span');
    customPrice.className = 'cpb-custom-product-price';
    customPrice.textContent = formatPrice(realPrice.textContent);

    priceWrapper.appendChild(customPrice);
    container.appendChild(priceWrapper);

    state.customPricesContainer = container;
    state.builder.dataset.customProductPrice = 'true';
    ensureFreeAddonTeaser();

    const updatePrice = () => {
      if (state.rafId) return;
      state.rafId = requestAnimationFrame(() => {
        state.rafId = null;
        const currentPriceEl = findBestPriceEl() || realPrice;
        customPrice.textContent = formatPrice(currentPriceEl.textContent);

        // Update Clearpay on price change (Klarna stays static)
        updateAfterpayDebounced();
      });
    };

    state.priceObserver = new MutationObserver(updatePrice);
    state.priceObserver.observe(realPrice, {
      childList: true,
      characterData: true,
      subtree: true
    });

    return true;
  }

  /* -------------------------------------------
   * Klarna (static base price — never updates)
   * ----------------------------------------- */
  function initKlarnaPlacement() {
    if (!CONFIG.ENABLE_KLARNA || state.klarnaInitialized) return false;

    const nodes = document.querySelectorAll(CONFIG.KLARNA_FIND_SEL);
    if (!nodes.length || !window.KlarnaOnsiteService) return false;

    state.klarnaInitialized = true;

    // Set base price once and never update
    if (!state.klarnaBasePence) {
      const pounds = getPriceFromCPBState() ?? getPriceFromDOMFallback();
      const pence = poundsToPenceInt(pounds);

      if (pence) {
        state.klarnaBasePence = pence;
        nodes.forEach(node => {
          node.setAttribute('data-purchase-amount', String(pence));
        });
      }
    }

    // Move into our container
    if (!state.movedKlarnaOnce && state.klarnaWrap) {
      state.klarnaWrap.append(...nodes);
      state.movedKlarnaOnce = true;
    }

    // Refresh
    utils.setTrackedTimeout(() => {
      if (window.KlarnaOnsiteService?.push) {
        window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
      }
    }, 100);

    return true;
  }

  function hookKlarnaAsyncCallback() {
    const prev = window.klarnaAsyncCallback;
    if (prev && prev.__cpbWrapped) return;

    window.klarnaAsyncCallback = function () {
      try { if (typeof prev === 'function') prev(); } catch (_) {}

      utils.setTrackedTimeout(() => {
        state.klarnaInitialized = false;
        initKlarnaPlacement();
      }, 100);
    };
    window.klarnaAsyncCallback.__cpbWrapped = true;
  }

  /* -------------------------------------------
   * Clearpay / Afterpay (updates dynamically)
   * ----------------------------------------- */
  function findAfterpayTemplate() {
    return utils.qs('[data-cpb-afterpay-placement]')
      || utils.qs('[data-afterpay-product-placement]');
  }

  function buildAfterpayPlacement(amountValue) {
    const template = findAfterpayTemplate();
    let placement = null;

    if (template && template.tagName && template.tagName.toLowerCase() === 'square-placement') {
      placement = template.cloneNode(true);
    } else {
      placement = document.createElement('square-placement');
      placement.setAttribute('data-mpid', '82c70122-b711-43ac-80a9-d3edde26ee88');
      placement.setAttribute('data-placement-id', '89eb413b-d599-4104-aa59-c47c2f3c75b0');
      placement.setAttribute('data-page-type', 'product');
      placement.setAttribute('data-currency', 'GBP');
      placement.setAttribute('data-consumer-locale', 'en-GB');
      placement.setAttribute('data-is-eligible', 'true');
    }

    placement.removeAttribute('data-cpb-afterpay-placement');
    placement.removeAttribute('data-afterpay-product-placement');
    placement.setAttribute('data-amount', amountValue);

    return placement;
  }

  function updateAfterpay() {
    if (!CONFIG.ENABLE_AFTERPAY || !state.afterpayWrap || state.updatingAfterpay) return;

    state.updatingAfterpay = true;
    try {
      const pounds = getPriceFromCPBState() ?? getPriceFromDOMFallback();
      const amount = Number(pounds);
      if (!Number.isFinite(amount) || amount <= 0) return;

      const formattedAmount = amount.toFixed(2);
      const existingPlacement = state.afterpayWrap.querySelector('square-placement');
      if (state.lastAfterpayAmount === formattedAmount && existingPlacement) return;

      const placement = buildAfterpayPlacement(formattedAmount);
      state.afterpayWrap.replaceChildren(placement);
      state.lastAfterpayAmount = formattedAmount;
    } finally {
      state.updatingAfterpay = false;
    }
  }

  function updateAfterpayDebounced() {
    if (state.afterpayDebounceTimer) clearTimeout(state.afterpayDebounceTimer);
    state.afterpayDebounceTimer = setTimeout(() => {
      state.afterpayDebounceTimer = null;
      updateAfterpay();
    }, CONFIG.AFTERPAY_DEBOUNCE);
  }

  /* -------------------------------------------
   * Description move
   * ----------------------------------------- */
  function moveDescriptionOnce(mountId) {
    const description = utils.qs('.product-block--description');
    const cpbDescription = utils.qs('.cpb-product-description');

    if (!description || !cpbDescription) return false;

    const move = () => {
      if (state.mountedId !== mountId) return;
      cpbDescription.replaceChildren(description);
    };

    const personalizeButton = utils.qs('.personalize-it--js');
    if (personalizeButton) {
      personalizeButton.addEventListener('click', move, { once: true });
    } else {
      move();
    }

    return true;
  }

  /* -------------------------------------------
   * DOM placement
   * ----------------------------------------- */
  function ensureKlarnaWrap() {
    if (!CONFIG.ENABLE_KLARNA || state.klarnaWrap) return;
    state.klarnaWrap = document.createElement('div');
    state.klarnaWrap.className = 'cpb-klarna-container';
  }

  function ensureAfterpayWrap() {
    if (!CONFIG.ENABLE_AFTERPAY || state.afterpayWrap) return;
    state.afterpayWrap = document.createElement('div');
    state.afterpayWrap.className = 'cpb-afterpay-container';
  }

  function refreshKlaviyoWidgets() {
    if (window.__gpKlaviyoReviews && typeof window.__gpKlaviyoReviews.refresh === 'function') {
      window.__gpKlaviyoReviews.refresh(document);
      return true;
    }

    if (window.klReviewsObject && typeof window.klReviewsObject.renderWidgets === 'function') {
      try {
        window.klReviewsObject.renderWidgets();
        return true;
      } catch (_) {}
    }

    return false;
  }

  function findFreeAddonAnchor(fallbackEl) {
    const candidates = [
      state.afterpayWrap,
      state.klarnaWrap,
      utils.qs('.cpb-afterpay-container'),
      utils.qs('.cpb-klarna-container')
    ].filter(Boolean);

    const dynamicBnplNodes = Array.from(utils.qsa(
      '.cpb-panels-container square-placement, .cpb-panels-container klarna-placement, .product__information square-placement, .product__information klarna-placement'
    )).filter(node => {
      if (!utils.isElementShown(node)) return false;
      return !node.closest('[style*="display:none"]');
    });

    candidates.push.apply(candidates, dynamicBnplNodes);

    const connected = candidates.filter(node => utils.isElementShown(node));
    return connected[connected.length - 1] || fallbackEl;
  }

  function placeElements(mountId) {
    if (state.mountedId !== mountId) return false;

    const productTitle = utils.qs('.cpb-product-title', state.panelsContainer);
    if (!productTitle) return false;

    const ratingStars = utils.qs('.product__information .klaviyo-star-rating-widget');

    ensureCustomPriceContainer();
    ensureFreeAddonTeaser();
    ensureKlarnaWrap();
    ensureAfterpayWrap();

    // Stars after title
    if (ratingStars && ratingStars.parentElement !== productTitle.parentElement) {
      productTitle.insertAdjacentElement('afterend', ratingStars);
    }

    // Price after stars (or title)
    const priceTarget = ratingStars || productTitle;
    if (state.customPricesContainer && !state.customPricesContainer.isConnected) {
      priceTarget.insertAdjacentElement('afterend', state.customPricesContainer);
    }

    // Klarna after price
    let lastEl = state.customPricesContainer || priceTarget;
    if (state.klarnaWrap && !state.klarnaWrap.isConnected) {
      lastEl.insertAdjacentElement('afterend', state.klarnaWrap);
      lastEl = state.klarnaWrap;
    }

    // Clearpay after Klarna
    if (state.afterpayWrap && !state.afterpayWrap.isConnected) {
      lastEl.insertAdjacentElement('afterend', state.afterpayWrap);
      lastEl = state.afterpayWrap;
    }

    // Free add-on after the last visible BNPL option (or after price if unavailable)
    if (state.freeAddonTeaser) {
      const freeAddonAnchor = findFreeAddonAnchor(lastEl);
      if (state.freeAddonTeaser.previousElementSibling !== freeAddonAnchor || state.freeAddonTeaser.parentElement === state.customPricesContainer) {
        freeAddonAnchor.insertAdjacentElement('afterend', state.freeAddonTeaser);
      }
    }

    return true;
  }

  function syncDynamicBuilderElements() {
    if (!state.mountedId) return;

    ensureCustomPriceContainer();
    ensureFreeAddonTeaser();
    ensureKlarnaWrap();
    ensureAfterpayWrap();
    syncPreorderState();

    utils.retry(() => placeElements(state.mountedId));
  }

  /* -------------------------------------------
   * Inject CSS (hides original price)
   * ----------------------------------------- */
  function injectCSSOnce() {
    if (document.getElementById('cpb-payments-layout')) return;

    const style = document.createElement('style');
    style.id = 'cpb-payments-layout';
    style.textContent = `
      #product-builder .cpb-panels-container .cpb-product-price {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }

  /* -------------------------------------------
   * Navigation button removal (JS backup)
   * ----------------------------------------- */
  const NAV_REGEX = /PREVIOUS|NEXT|RESET|PREVIOUS TAB|NEXT TAB/i;

  function removeNavigationButtons() {
    const buttons = utils.qsa('.cpb-product-actions button, .cpb-product-actions .cpb-actions-btn');
    if (!buttons.length) return false;

    let removed = 0;
    buttons.forEach(btn => {
      if (NAV_REGEX.test((btn.textContent || '').trim())) {
        btn.remove();
        removed++;
      }
    });

    return removed > 0;
  }

  /* -------------------------------------------
   * Out of stock overlays
   * ----------------------------------------- */
  function updateOutOfStockOverlays() {
    const wrappers = utils.qsa('.out-stock-wrapper');
    if (!wrappers.length) return false;

    wrappers.forEach(wrapper => {
      const overlay = utils.qs('.out-stock-overlay span', wrapper);
      const img = utils.qs('img', wrapper);
      if (!overlay || !img) return;

      const title = (img.alt || 'Product')
        .replace(/\s*\([^)]*\)\s*$/g, '')
        .trim();

      overlay.textContent = `${title} - OUT OF STOCK`;
    });

    return true;
  }

  /* -------------------------------------------
   * Init
   * ----------------------------------------- */
  function init() {
    cleanup();
    state.mountedId = utils.newMountId();
    const mountId = state.mountedId;

    if (!initGlobals()) {
      utils.error('Product builder not found');
      return;
    }

    state.freeAddonData = getFreeAddonData();
    injectCSSOnce();
    window.PXUTheme.contentCreator.accordion?.init?.();

    ensureCustomPriceContainer();
    syncPreorderState();

    utils.retry(() => moveDescriptionOnce(mountId));
    utils.retry(() => placeElements(mountId));
    utils.retry(syncPreorderState);
    utils.retry(refreshKlaviyoWidgets, [0, 120, 350, 800, 1500, 2500, 4000, 6500, 9000, 12000]);

    // Navigation button removal (backup to CSS hide)
    utils.retry(removeNavigationButtons);

    // Klarna init (static, retried until Klarna SDK loads)
    if (CONFIG.ENABLE_KLARNA) {
      hookKlarnaAsyncCallback();
      utils.retry(initKlarnaPlacement);
      utils.setTrackedTimeout(() => initKlarnaPlacement(), 1200);
      utils.setTrackedTimeout(() => initKlarnaPlacement(), 2500);
    }

    // Clearpay init
    if (CONFIG.ENABLE_AFTERPAY) {
      utils.retry(updateAfterpayDebounced);
    }

    // Out of stock overlays
    CONFIG.OOS_RETRY_DELAYS_MS.forEach(delay => {
      utils.setTrackedTimeout(() => updateOutOfStockOverlays(), delay);
    });
  }

  // Listen for CPB events
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);

  document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', () => {
    // CPB can reflow payment/add-on nodes on selection, so re-assert placement.
    syncDynamicBuilderElements();

    // Only update Clearpay amount on option change (Klarna stays static)
    updateAfterpayDebounced();
  });

  window.addEventListener('pagehide', cleanup);
  window.addEventListener('beforeunload', cleanup);
})();
